import { z } from 'zod';

export const apiKeySchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().min(1, 'Description is required'),
});
export type ApiKeyFormValues = z.infer<typeof apiKeySchema>;
